import React, { useEffect, useState } from "react"; // Add missing import statement
import moment from "moment";
import { Link } from "react-router-dom";
import Select from "react-select";
import {
  getWithdrawalBank,
  postWithdrawalRequest,
} from "../../Service/WithdrawService";
import { NumberFormat } from "../../Components/NumberFormat";
import Swal from "sweetalert2";
import _, { set } from "lodash";

const { $ } = window;
const WithdrawalForm = (state) => {
  const hideModal = () => {
    $("#modalWithdrawalForm").modal("hide");
  };

  const [stateWithdrawalForm, setStateWithdrawalForm] = useState({
    MHCName: "",
    bankAccount: [],
    selectedBankAccount: {},
    bankAccountName: "",
  });

  const [withdrawing, setWithdrawing] = useState(false);

  const getHMCName = () => {
    state.listMHC.map((item) => {
      if (item.value === state.selectedListMHC) {
        setStateWithdrawalForm((prev) => {
          return {
            ...prev,
            MHCName: item.label,
          };
        });
      }
    });
  };

  const getWithdrawalBankList = () => {
    getWithdrawalBank(state.selectedListMHC)
      .then((res) => {
        setStateWithdrawalForm((prev) => {
          return {
            ...prev,
            bankAccount: res.data?.map((item) => {
              return {
                value: item.BankCode + " - " + item.Account,
                label: item.BankCode + " - " + item.Account,
              };
            }),
            bankAccountName: res.data !== null ? res.data[0].Name : "",
          };
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const submitWithdrawalRequest = () => {
    setWithdrawing(true);
    let payload = {
      MHC: state.selectedListMHC,
      BankCode: stateWithdrawalForm.selectedBankAccount.bank,
      Account: stateWithdrawalForm.selectedBankAccount.account,
      AccountHolder: stateWithdrawalForm.bankAccountName,
      Amount: state.balance.net_amount,
      WithdrawalList: state.withdrawalList,
    };
    //console.log(payload);
    postWithdrawalRequest(payload)
      .then((res) => {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Withdrawal request has been submitted.",
        }).then(() => {
          setWithdrawing(false);
          //console.log(state.onChangeTable)
          setStateWithdrawalForm({
            ...stateWithdrawalForm,
            MHCName: "",
            bankAccount: [],
            selectedBankAccount: {},
            bankAccountName: "",
          });
          state.onChangeTable();
          state.onChangeSummary();
          hideModal();
        });
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err.message,
        }).then((_) => {
          setWithdrawing(false);
        });
        console.log(err);
      });
  };

  useEffect(() => {
    getHMCName();
    if (state.selectedListMHC !== "") getWithdrawalBankList();
  }, [state.selectedListMHC]);

  return (
    <div className="container-fluid" style={{ padding: "37px" }}>
      <div className="row">
        <div
          className="col-md-12"
          style={{ alignContent: "center", paddingBottom: "27px" }}
        >
          <h4>Withdrawal Form</h4>
        </div>
        <div style={{ position: "absolute", right: "17px", top: "17px" }}>
          <Link style={{ textDecoration: "none" }}>
            <h5 onClick={hideModal}>X</h5>
          </Link>
        </div>
      </div>
      <div style={{ lineHeight: "37px" }}>
        <div className="row" style={{ lineHeight: "27px" }}>
          You are about to withdraw from your Payment Gateway account. Please
          fill in the form below.
        </div>
        <div className="row" style={{ padding: "17px 0px 17px 0px" }}>
          <h5>Net amount balance : {NumberFormat(state.balance.net_amount)}</h5>
        </div>
        <div className="row">Store : {stateWithdrawalForm.MHCName}</div>
        <div className="row">
          Select Bank Account
          <Select
            value={{
              label:
                stateWithdrawalForm.selectedBankAccount.bank !== undefined
                  ? stateWithdrawalForm.selectedBankAccount.bank +
                    " - " +
                    stateWithdrawalForm.selectedBankAccount.account
                  : "Select Bank Account",
              value:
                stateWithdrawalForm.selectedBankAccount.bank !== undefined
                  ? stateWithdrawalForm.selectedBankAccount.bank +
                    " - " +
                    stateWithdrawalForm.selectedBankAccount.account
                  : "",
            }}
            options={stateWithdrawalForm.bankAccount}
            onChange={(e) => {
              let bankAccountCode = e.value.split(" - ");
              setStateWithdrawalForm((prev) => {
                return {
                  ...prev,
                  selectedBankAccount: {
                    bank: bankAccountCode[0],
                    account: bankAccountCode[1],
                  },
                };
              });
            }}
            styles={{
              control: (styles) => ({
                ...styles,
                minWidth: "300px",
                marginLeft: "17px",
              }),
            }}
          />
        </div>
        {stateWithdrawalForm.selectedBankAccount.bank !== undefined && (
          <div style={{ paddingTop: "17px" }}>
            <div className="row">
              <h5>Bank Account Information </h5>
            </div>
            <div className="row">
              Bank Name : {stateWithdrawalForm.selectedBankAccount.bank}
            </div>
            <div className="row">
              Account Number : {stateWithdrawalForm.selectedBankAccount.account}
            </div>
            <div className="row">
              Account Name : {stateWithdrawalForm.bankAccountName}
            </div>
            <button
              className="btn btn-primary"
              style={{ marginTop: "17px" }}
              disabled={withdrawing}
              onClick={submitWithdrawalRequest}
            >
              Submit Withdrawal Request
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default WithdrawalForm;
